export const conditionalItem = <T>(condition, item: T): T[] => {
  return condition ? [item] : [];
};
